import instance from "./axiosConfig";

export const useFuturasTareasStore = () => {
  const findAllFuturasTareas = async () => {
    try {
      const response = await instance.get("/futurasTareas");
      return response.data;
    } catch (error) {
      console.error("Error al encontrar tareas:", error);
      throw error;
    }
  };

  const eliminarTarea = async (id: number) => {
    try {
      const response = await instance.delete("/futurasTareas/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al elimanr una tarea:", error);
      throw error;
    }
  };

  const empezarTarea = async (id: number, nombre: string, descripcion: string) => {
    try {
      const response = await instance.post("/futurasTareas/empezar", {
        id: id,
        descripcion: descripcion,
        nombre: nombre,
      });
      return response.data;
    } catch (error) {
      console.error("Error al empezar una tarea:", error);
      throw error;
    }
  };

  const findFuturaTareaById = async (id: string) => {
    try {
      const response = await instance.get("/futurasTareas/" + id);
      return response.data;
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error;
    }
  };

  const createTarea = async (
    id: string | null,
    nombre: string,
    descripcion: string,
    prioridad: string
  ) => {
    try {
      const response = await instance.post("/futurasTareas/crearTarea", {
        id: id ? id : null,
        descripcion: descripcion,
        nombre: nombre,
        prioridad: prioridad
      });
      return response.data;
    } catch (error) {
      console.error("Error al crear la futura tarea:", error);
      throw error;
    }
  };

  return {
    findAllFuturasTareas,
    eliminarTarea,
    createTarea,
    findFuturaTareaById,
    empezarTarea
  };
};
